<template>
  <div>
    <b-modal
      id="categorias-filtro-global"
      content-class="bg-dark-mx3--"
      fullscreen
      hide-header
      hide-footer
    >
      <b-row>
        <b-col
          class="d-flex mb-4 cursor-pointer justify-content-end"
          @click="$bvModal.hide('categorias-filtro-global')"
        >
          <span class="text-muted text-right"
            ><b-icon-chevron-left></b-icon-chevron-left> Fechar</span
          >
          <div class=""></div>
        </b-col>
      </b-row>
      <div class="bg-dark-mx3--">
        <b-row>
          <b-col>
            <div class="filter-group mb-4">
              <h5 class="text-center filter-title mb-2">
                <span class="mx3-sidebar-title-text">Categorias</span>
              </h5>

              <ul class="list-unstyled category-list">
                <li class="mb-2">
                  <div
                    style="border-radius: 7px"
                    :class="[
                      'filter-item cursor-pointer',
                      { 'is-active': categoriaSelecionada === null },
                    ]"
                    @click="filterByCategoria(null)"
                  >
                    <span class="category-name">Todas as categorias</span>
                  </div>
                </li>
                <li
                  v-for="(categoria, i) in categoriasOrdenadas"
                  :key="'cat-' + i"
                  class="mb-2 categoria-item--"
                  :class="{
                    'categoria-ativa':
                      categoria && categoriaSelecionada === (categoria.id || categoria.nome) &&
                      subcategorias.length > 0,
                  }"
                >
                  <div
                    style="border-radius: 7px"
                    :class="[
                      'filter-item cursor-pointer',
                      { 'is-active': categoriaSelecionada === (categoria.id || categoria.nome) },
                    ]"
                    @click="filterByCategoria(categoria)"
                  >
                    <span class="category-name">{{ categoria.nome }}</span>
                    <b-icon
                      v-if="categoriaSelecionada === (categoria.id || categoria.nome) && subcategorias.length > 0"
                      icon="chevron-up"
                      class="ml-auto mr-2"
                      style="font-size: 0.8rem"
                    ></b-icon>
                    <b-icon
                      v-else-if="categoria.temSubcategorias !== false"
                      icon="chevron-down"
                      class="ml-auto mr-2"
                      style="font-size: 0.8rem"
                    ></b-icon>
                  </div>

                  <b-collapse
                    :visible="categoriaSelecionada === (categoria.id || categoria.nome)"
                    class="mt-2 subcategorias-container"
                  >
                    <ul
                      class="list-unstyled subcategorias-list"
                      style="margin-left: 20px"
                    >
                      <li
                        v-for="(subcat, j) in subcategorias"
                        :key="'sub-' + j"
                        class="mb-2 subcategoria-item--"
                      >
                        <div
                          style="border-radius: 7px"
                          :class="[
                            'filter-item cursor-pointer',
                            {
                              'is-active':
                                subcategoriaSelecionada === subcat.id,
                            },
                          ]"
                          @click.stop="filterBySubcategoria(subcat)"
                        >
                          <span class="category-name">{{ subcat.nome }}</span>
                        </div>
                      </li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { apiCache } from "@/utils/apiCache";

export default {
  data() {
    return {
      categorias: [],
      categoriaSelecionada: null,
      subcategorias: [],
      subcategoriaSelecionada: null,
      filtrosList: [],
      filtroProdutoSelecionado: null,
    };
  },

  async mounted() {
    await this.loadCategorias();
    await this.initializeFromQuery();
  },

  methods: {
    async loadCategorias() {
      try {
        const res = await apiCache.fetch(
          'categorias',
          () => this.$api.getCategorias(),
          {},
          10 * 60 * 1000
        );
        this.categorias = res.data || [];
      } catch (e) {
        console.error("Erro ao carregar categorias no mobile:", e);
      }
    },

    async initializeFromQuery() {
      const q = this.$route.query;

      if (q.categoria) {
        this.categoriaSelecionada = q.categoria;
        await this.loadSubcategoriasAsync();
      } else {
        this.categoriaSelecionada = null;
        this.subcategorias = [];
      }

      if (q.subcategoria) {
        this.subcategoriaSelecionada = q.subcategoria;
      } else {
        this.subcategoriaSelecionada = null;
      }

      if (q.filtroproduto) {
        this.filtroProdutoSelecionado = q.filtroproduto;
      } else {
        this.filtroProdutoSelecionado = null;
      }
    },

    async loadSubcategoriasAsync() {
      if (!this.categoriaSelecionada) {
        this.subcategorias = [];
        return;
      }
      try {
        // $api.host já resolve para o Gerenciador (com fallback automático
        // para localhost em dev) - não existe mais o antigo endpoint
        // dados_proxy.php do Railway, então usamos sempre dados_api.php.
        const url = `${this.$api.host}/api/dados_api.php`;
        const res = await apiCache.fetch('dados_api_all', () => this.$api.httpService().get(url), {}, 5 * 60 * 1000);
        const structure = res.data.categoryStructure || {};
        const categoryData = structure[this.categoriaSelecionada] || {};
        const subcatsObj = categoryData.subcategories || {};
        const subcats = Object.keys(subcatsObj);
        this.subcategorias = subcats.map(s => ({ id: s, nome: s }));
      } catch (error) {
        console.error("Erro ao carregar subcategorias:", error);
      }
    },

    resetState() {
      this.categoriaSelecionada = null;
      this.subcategoriaSelecionada = null;
      this.filtroProdutoSelecionado = null;
      this.subcategorias = [];
      this.filtrosList = [];
    },

    fecharEForcarRecarregamento() {
      // Fecha o modal e permite navegação fluida sem recarregar a página inteira
      this.$bvModal.hide("categorias-filtro-global");
    },

    async filterByCategoria(categoria) {
      if (categoria === null) {
        this.resetState();
        this.$router.push({ name: 'products', query: {} }).catch(() => {});
        this.fecharEForcarRecarregamento();
        return;
      }

      const catId = categoria.id || categoria.nome;
      
      if (String(this.categoriaSelecionada) === String(catId)) {
        this.categoriaSelecionada = null;
        this.subcategorias = [];
        this.subcategoriaSelecionada = null;
        return;
      }

      this.categoriaSelecionada = catId;
      this.subcategoriaSelecionada = null;
      this.filtroProdutoSelecionado = null;
      this.subcategorias = [];
      
      await this.loadSubcategoriasAsync();

      if (this.subcategorias.length === 0) {
        this.$router.push({ 
          name: 'products', 
          query: { categoria: this.categoriaSelecionada } 
        }).catch(() => {});
        this.fecharEForcarRecarregamento();
      }
    },

    filterBySubcategoria(subcat) {
      this.subcategoriaSelecionada = subcat.id;
      this.filtroProdutoSelecionado = null;
      
      this.$router.push({ 
        name: 'products', 
        query: { 
          categoria: this.categoriaSelecionada,
          subcategoria: this.subcategoriaSelecionada 
        } 
      }).catch(() => {});
      this.fecharEForcarRecarregamento();
    }
  },

  computed: {
    categoriasOrdenadas() {
      let lista = this.categorias || [];
      const ordem = ["Ferramentas Elétricas e Máquinas", "Equipamento Auto Center", "Ferramentas Manuais", "Injeção Eletrônica e Motor", "Ferramentas Pneumáticas", "Lava Jato e Posto", "Ferramentas Automotivas", "Jardinagem", "Construção Civil", "Funilaria e Pintura", "Auto Elétrica", "Ferramentas Para Motos", "EPI", "Borracharia", "Ferramentas em Geral", "Equipamento Caminhões", "Para Você e Sua Casa", "Aditivos e Lubrificantes", "Movimentação e Carga", "Camping e Hobby"];
      
      return [...lista].sort((a, b) => {
        const indexA = ordem.indexOf(a.nome);
        const indexB = ordem.indexOf(b.nome);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return 0;
      });
    }
  },

  watch: {
    '$route.query': {
      handler: 'initializeFromQuery',
      immediate: false
    }
  }
};
</script>

<style scoped lang="scss">
.bg-dark-mx3-- {
  background: var(--mx3-style-bg-card, #1c1e20) !important;
  background-color: var(--mx3-style-bg-card, #1c1e20) !important;
}

.filter-group {
  padding: 10px !important;
}

.filter-title {
  font-size: 1.1rem !important;
  font-weight: bold !important;
}

.category-list {
  padding-left: 0 !important;
}

.filter-item {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 8px 10px !important;
  border-radius: 7px !important;
  transition: all 0.3s ease !important;
  background: var(--mx3-style-bg-card, #1c1e20) !important;
  border: 0.5px solid #e5e5e520 !important;
  color: #e5e5e5 !important;
}

.filter-item:hover:not(.is-active) {
  border: 0.5px solid var(--mx3-style-primary, #ff6600) !important;
  color: var(--mx3-style-primary, #ff6600) !important;
}

.filter-item.is-active {
  border: 0.5px solid var(--mx3-style-primary, #ff6600) !important;
  color: var(--mx3-style-primary, #ff6600) !important;
  background: linear-gradient(90deg, var(--mx3-style-primary-a20, #ff660020) 0%, transparent 100%) !important;
}

.category-name {
  padding: 5px;
}

.subcategorias-list {
  position: relative;
  margin-left: 15px !important;
  padding-left: 10px !important;
}

.subcategorias-list::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 10px;
  width: 2px;
  background: linear-gradient(
    to bottom,
    var(--mx3-style-primary, #ff6600) 0%,
    var(--mx3-style-primary-acc, #ff6600cc) 30%,
    var(--mx3-style-primary-a99, #ff660099) 60%,
    var(--mx3-style-primary-a44, #ff660044) 85%,
    rgba(255, 102, 0, 0.2) 100%
  );
  border-radius: 2px;
}
</style>
